import { useState, useEffect } from 'react';
import { setupDiscord, getAuth, type DiscordAuth } from '../discord';

interface DiscordState {
  auth: DiscordAuth | null;
  loading: boolean;
  error: string | null;
}

export function useDiscord(): DiscordState {
  const [state, setState] = useState<DiscordState>({
    auth: getAuth(),
    loading: !getAuth(),
    error: null,
  });

  useEffect(() => {
    if (state.auth) return;

    setupDiscord()
      .then((auth) => setState({ auth, loading: false, error: null }))
      .catch((err) => setState({ auth: null, loading: false, error: err.message }));
  }, []);

  return state;
}
